import { Recommends } from "api-client";

export enum ACTIONS {
    GET_RECOMMENDS_REQUEST = "RECOMMENDS/GET_RECOMMENDS_REQUEST",
    GET_RECOMMENDS_SUCCESS = "RECOMMENDS/GET_RECOMMENDS_SUCCESS",
    GET_RECOMMENDS_FAILURE = "RECOMMENDS/GET_RECOMMENDS_FAILURE",
}

interface GetRecommendsRequest {
    type: ACTIONS.GET_RECOMMENDS_REQUEST;
}

interface GetRecommendsSuccess {
    type: ACTIONS.GET_RECOMMENDS_SUCCESS;
    payload: Recommends;
}

interface GetRecommendsFailure {
    type: ACTIONS.GET_RECOMMENDS_FAILURE;
}

export type ActionType = GetRecommendsRequest | GetRecommendsSuccess | GetRecommendsFailure;
